module.exports = __webpack_public_path__ + "static/media/eina04-bold.abbc1963.woff";